/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import ChatTicketModel from "@/models/createTicket/ChatTicketModel";
import TicketModel from "@/models/createTicket/TicketModel";
import ProgressTicketModel from "@/models/createTicket/ProgressTicketModel";
import FilterModel from "@/models/FilterModel";
import AssessmentModel from "@/models/createTicket/AssessmentModel";
import Axios, { AxiosRequestConfig } from "axios";
import AssessmentSaveModel from "@/models/createTicket/AssessmentSaveModel";
import ResourceModel from "@/models/createTicket/ResourceModel";
import FeedbackModel from "@/models/createTicket/FeedbackModel";
import FeedbackApprovalModel from "@/models/createTicket/FeedbackApprovalModel";
import ActivityModel from "@/models/createTicket/ActivityModel";

const axios = Axios.create();

axios.interceptors.request.use((req) => {
  req.baseURL = process.env.VUE_APP_SALUTARIA_API_URL + "/api";
  req.headers!.authorization = `Bearer ${localStorage.authToken}`;
  return req;
});
export default {
  getMyTask() {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/ticket/mytask",
    };
    return axios(options);
  },
  getMyTaskSearch(search: string | null) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/ticket/mytask",
      params: {
        search: search,
      },
    };
    return axios(options);
  },
  getMyTaskFilter(payload: FilterModel) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/ticket/mytask",
      params: payload,
    };
    return axios(options);
  },
  getMyTaskByDate(date: string | null) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/ticket/mytask",
      params: {
        date: date,
      },
    };
    return axios(options);
  },
  getDetailTicket2(idTicket: string | null) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/v2/ticket/detail/" + idTicket,
    };
    return axios(options);
  },
  getDetailTask(idTicket: string | null) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/ticket/" + idTicket + "/detail",
    };
    return axios(options);
  },
  getDetailTask2(idTicket: string | null) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/v2/workorder/detail/" + idTicket,
    };
    return axios(options);
  },
  getMyTask2(page = 1) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/v2/workorder/list?page="+page,
    };
    return axios(options);
  },
  getMyTaskSearch2(search: string | null, page = 1) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/v2/workorder/list",
      params: {
        search: search,
        page: page
      },
    };
    return axios(options);
  },
  getMyTaskFilter2(payload: FilterModel) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/v2/workorder/list",
      params: payload,
    };
    return axios(options);
  },
  getMyTaskByDate2(date: string | null) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/v2/workorder/list",
      params: {
        date: date,
      },
    };
    return axios(options);
  },
  getListProgress(idTicket: string | null) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/ticket/" + idTicket + "/progress",
    };
    return axios(options);
  },
  getListProgressSearch(idTicket: string | null, search: string | null) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/ticket/" + idTicket + "/progress",
      params: {
        search: search,
      },
    };
    return axios(options);
  },
  createProgress(idTicket: string | null, payload: ProgressTicketModel) {
    const options: AxiosRequestConfig = {
      method: "post",
      url: "/ticket/" + idTicket + "/progress/create",
      data: payload,
    };
    return axios(options);
  },
  approvalProgressSupervisor(
    idTicket: string | null,
    idProgress: string | null,
    status: string | null,
    message: string | null
  ) {
    const options: AxiosRequestConfig = {
      method: "post",
      url: "/ticket/" + idTicket + "/progress/" + idProgress + "/status/supervisor",
      data: {
        status: status,
        message: message,
      },
    };
    return axios(options);
  },
  approvalProgressUser(
    idTicket: string | null,
    idProgress: string | null,
    status: string | null,
    message: string | null
  ) {
    const options: AxiosRequestConfig = {
      method: "post",
      url: "/ticket/" + idTicket + "/progress/" + idProgress + "/status/user",
      data: {
        status: status,
        message: message,
      },
    };
    return axios(options);
  },

  getMyTicket() {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/ticket/myticket",
    };
    return axios(options);
  },
  getMyTicketSearch(search: string | null) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/ticket/myticket",
      params: {
        search: search,
      },
    };
    return axios(options);
  },
  getMyTicketFilter(payload: FilterModel) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/ticket/myticket",
      params: payload,
    };
    return axios(options);
  },
  getMyTicketByDate(date: string | null) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/ticket/myticket",
      params: {
        date: date,
      },
    };
    return axios(options);
  },
  getMyTicket2(page = 1) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/v2/ticket/myticket?page="+page,
    };
    return axios(options);
  },
  getMyTicketSearch2(search: string | null, page = 1) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/v2/ticket/myticket",
      params: {
        search: search,
        page: page
      },
    };
    return axios(options);
  },
  getMyTicketFilter2(payload: FilterModel) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/v2/ticket/myticket",
      params: payload,
    };
    return axios(options);
  },
  getMyTicketByDate2(date: string | null) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/v2/ticket/myticket",
      params: {
        date: date,
      },
    };
    return axios(options);
  },

  getListChat(idTicket: string | null) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/ticket/" + idTicket + "/chat/list",
    };
    return axios(options);
  },
  saveTicket(payload: TicketModel) {
    const options: AxiosRequestConfig = {
      method: "post",
      url: "/ticket/create",
      data: payload,
    };
    return axios(options);
  },
  saveTicket2(payload: TicketModel) {
    const options: AxiosRequestConfig = {
      method: "post",
      url: "/v2/ticket/create",
      data: payload,
    };
    return axios(options);
  },
  saveTicket3(payload: TicketModel) {
    const options: AxiosRequestConfig = {
      method: "post",
      url: "/v3/ticket/create",
      data: payload,
    };
    return axios(options);
  },
  sendChat(payload: ChatTicketModel, idTicket: string | null) {
    const options: AxiosRequestConfig = {
      method: "post",
      url: "/ticket/" + idTicket + "/chat/send",
      data: {
        message: payload.message,
        message_type: payload.message_type,
      },
    };
    return axios(options);
  },

  getAssessment(idTicket: string | null) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/v2/workorder/assessment/detail/" + idTicket,
    };
    return axios(options);
  },
  saveAssessment(payload: AssessmentSaveModel) {
    const options: AxiosRequestConfig = {
      method: "post",
      url: "/v2/workorder/assessment/create",
      data: payload,
    };
    return axios(options);
  },

  saveResource(payload: ResourceModel) {
    const options: AxiosRequestConfig = {
      method: "post",
      url: "/v2/workorder/additional-resource/create",
      data: payload,
    };
    return axios(options);
  },

  getResources(idTicket: string | null, page: number | null = 1) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/v2/workorder/additional-resource/list?work_orders_id=" + idTicket + "&page=" + page,
    };
    return axios(options);
  },
  getResource(idResource: string | null) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/v2/workorder/additional-resource/detail/" + idResource,
    };
    return axios(options);
  },

  saveActivity(payload: ActivityModel) {
    const options: AxiosRequestConfig = {
      method: "post",
      url: "/v2/activities/create",
      data: payload,
    };
    return axios(options);
  },

  getActivities(idTicket: string | null, page: number | null = 1) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/v2/activities/list?workorders_id=" + idTicket + "&page=" + page,
    };
    return axios(options);
  },
  getActivity(idActivity: string | null) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/v2/activities/detail/" + idActivity,
    };
    return axios(options);
  },

  saveFeedback(payload: FeedbackModel) {
    const options: AxiosRequestConfig = {
      method: "post",
      url: "/v2/workorder/feedback/create",
      data: payload,
    };
    return axios(options);
  },
  updateFeedback(payload: FeedbackModel) {
    const options: AxiosRequestConfig = {
      method: "post",
      url: "/v2/workorder/feedback/update",
      data: payload,
    };
    return axios(options);
  },

  getFeedbacks(idTicket: string | null) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/v2/workorder/feedback/" + idTicket,
    };
    return axios(options);
  },

  getFeedback(idFeedback: string | null) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/v2/workorder/feedback/detail/" + idFeedback,
    };
    return axios(options);
  },

  getHistory(idTicket: string | null) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/v2/workorder/history/" + idTicket,
    };
    return axios(options);
  },

  saveFeedbackApproval(payload: FeedbackApprovalModel) {
    const options: AxiosRequestConfig = {
      method: "post",
      url: "/v2/workorder/feedback/response",
      data: payload,
    };
    return axios(options);
  },


  getHistoryResource(idTicket: string | null) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/v2/workorder/additional-resource/history/" + idTicket,
    };
    return axios(options);
  },
};
